export class NotFoundError extends Error {
    constructor(message, metaData) {
        super(message)
        this.metaData = metaData
    }
}